import { Button, Form, Grid, Input, Picker, Tabs, TextArea, Toast } from "antd-mobile";
import React, { useEffect, useState } from "react";
import "./index.less";
import sdicHomeEmit from "@/utils/prototal";
import { isSdicHomeApp } from "@/utils/utils";
import useSWR from "swr";
import { activityApply, activityApplyrRecords, getActivityList } from "@/api/recreat-activity";
import { API_RESULT_CODE } from "@/config/types/common";
import { Helmet } from "react-helmet";
function RecreatActivity() {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [activeKey, setActiveKey] = useState("apply");
  const [desc, setDesc] = useState("");

  const { data: basicColumns } = useSWR("getUserInfo", async () => {
    const { code, data, msg } = await getActivityList();
    if (code === API_RESULT_CODE.SUCCESS) {
      const columns = data
        ? data.map((item: any) => {
            return {
              label: item.activityName,
              value: item.activityNo,
              desc: item.activityDesc,
            };
          })
        : [];
      return columns;
    }
    Toast.show(msg || "获取活动列表失败");
    return [];
  });

  const { data } = useSWR({ key: "activityApplyrRecords", activeKey }, async () => {
    if (activeKey === "record") {
      const { code, data, msg } = await activityApplyrRecords({ pageNum: 1, pageSize: 200 });
      if (code === API_RESULT_CODE.SUCCESS) {
        return data.list;
      }
      Toast.show(msg || "获取报名记录失败");
    }
    return [];
  });

  useEffect(() => {
    if (isSdicHomeApp()) {
      sdicHomeEmit("getUserInfo", {
        onCallback(data: any) {
          if (data) {
            try {
              const info = JSON.parse(data);
              form.setFieldsValue({
                ...info,
                realName: info.name,
                userId: info.username,
              });
            } catch (err) {
              console.error(err);
            }
          }
        },
      });
    }
  }, []);

  const onFinish = async () => {
    setLoading(true);
    //values.gongHuiId = "N1681194794058645504";
    //values.gongHuiName = "国投人力工会";
    const formData = await form.validateFields();
    formData.activityNo = formData.activityNo?.[0];
    const { code, msg } = await activityApply(formData);

    if (code === API_RESULT_CODE.SUCCESS) {
      Toast.show("填报成功");
    } else {
      Toast.show(msg);
    }
    setLoading(false);
  };
  const handleConfirm = (value: any, extend: any) => {
    console.log(value, extend?.items);
    setDesc(extend?.items?.[0]?.desc || "");
  };
  return (
    <div className="recreat-activity">
      <Helmet title="文体活动"></Helmet>
      <Tabs activeKey={activeKey} onChange={setActiveKey}>
        <Tabs.Tab title="信息填报" key="apply">
          <Form
            form={form}
            layout="horizontal"
            footer={
              <Button block type="submit" color="primary" size="large" loading={loading}>
                提交
              </Button>
            }
            onFinish={onFinish}
          >
            <Form.Item
              name="activityNo"
              label="活动名称"
              rules={[{ required: true, message: "活动名称不能为空" }]}
              trigger="onConfirm"
              onClick={() => {
                setVisible(true);
              }}
            >
              <Picker
                title="活动名称"
                columns={basicColumns ? [basicColumns] : []}
                visible={visible}
                onClose={() => setVisible(false)}
                onConfirm={handleConfirm}
              >
                {(items) =>
                  items.every((item) => item === null)
                    ? "未选择"
                    : items.map((item) => item?.label ?? "未选择").join(" - ")
                }
              </Picker>
            </Form.Item>
            <Form.Item name="desc" label="活动描述">
              {desc}
            </Form.Item>
            <Form.Item
              name="realName"
              label="姓名"
              rules={[{ required: true, message: "姓名不能为空" }]}
            >
              <Input placeholder="请输入姓名" />
            </Form.Item>
            <Form.Item
              name="userId"
              label="员工号"
              rules={[{ required: true, message: "员工号不能为空" }]}
            >
              <Input placeholder="请输入员工号" />
            </Form.Item>
            <Form.Item name="gongHuiId" label="所属工会" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="gongHuiName" label="所属工会">
              <Input readOnly />
            </Form.Item>
            <Form.Item
              name="phone"
              label="手机号"
              rules={[{ required: true, message: "手机号不能为空" }]}
            >
              <Input placeholder="请输入手机号" />
            </Form.Item>
            <Form.Item
              name="applyRemark"
              label="备注"
              rules={[{ required: true, message: "备注不能为空" }]}
            >
              <TextArea placeholder="请输入备注" maxLength={200} rows={4} showCount />
            </Form.Item>
          </Form>
        </Tabs.Tab>
        <Tabs.Tab title="报名记录" key="record">
          <Grid columns={3} gap={8} className="recreat-activity-table-row">
            <Grid.Item span={2}>
              <div className="recreat-activity-table-head">内容</div>
            </Grid.Item>
            <Grid.Item>
              <div className="recreat-activity-table-head">状态</div>
            </Grid.Item>
          </Grid>
          {data?.map((item, index) => (
            <Grid columns={3} gap={8} key={index} className="recreat-activity-table-row">
              <Grid.Item span={2}>
                <div className="recreat-activity-table-cell">{item.content}</div>
              </Grid.Item>
              <Grid.Item>
                <div className="recreat-activity-table-cell">{item.applyStatusDesc}</div>
              </Grid.Item>
            </Grid>
          ))}
        </Tabs.Tab>
      </Tabs>
    </div>
  );
}

export default RecreatActivity;
